const { createElement } = require('react')

const component = (spec) => {
  spec = Object.assign({}, spec)
  const render = ({ state, params, hub }) => spec.render.call(spec, state, params, hub)
  const Component = (state, params, hub) =>
    // Pretty sure this creates a new render context. Woo!
    createElement(render, { state, params, hub })
  Component.use = plugin => plugin(Component, spec)
  for (const plugin of component.plugins)
    Component.use(plugin)
  return Component
}
component.plugins = []
component.use = plugin => component.plugins.push(plugin)

module.exports = component